import React from "react";
import styled from "styled-components";
import colors from "../utils/colors";
import { Link } from "react-router-dom";
import { servicesData } from "../datas/services";


const Title = styled.h1`
    position: relative;
    padding: 0 1rem;
    margin: 5.5rem auto 1.5rem;
    text-align: center;
    font-size: clamp(2.1rem, 4vw, 3rem);
    line-height: 1.1;
    color: ${colors.primaryColor};
    
    span {
        color: ${colors.background};
    }

    @media screen and (max-width:770px) {
        font-size: 2.5rem;
    }
`;

const ServicesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.5rem;
    max-width: 1180px;
    margin: 0 auto 4rem;
    padding: 0 clamp(1rem, 4vw, 4rem);
    
    @media screen and (max-width:770px) {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
`;

const Services = styled.div`
    width: 100%;
    margin: 0;
    overflow: hidden;
    border-radius: 0.9rem;
    background: ${colors.textColor};
    box-shadow: 0 1rem 2rem rgba(69, 90, 100, 0.14);
    transition: all 0.3s ease-out;

    &:hover:before {
        opacity: 0.8;
    }

    &:hover {
        transform: translateY(-0.4rem);
    }

    @media screen and (max-width:770px) {
        width: 100%;
    }
`;

const ServiceImg = styled.div`
    img {
        width: 100%;
        height: 12rem;
        object-fit: cover;
    }
`;

const ServiceContent = styled.div`
    background-color: ${colors.textColor};
    width: 100%;
    min-height: 12rem;
    text-align: center;
    padding: 1.2rem 1rem 1.4rem;
    
    @media screen and (max-width:770px) {
        min-height: auto;
    }
`;

const ServiceTitle = styled.h5`
    margin-bottom: 0.8rem;
    font-size: 1.25rem;
    font-weight: 600;
    color: ${colors.background};
    line-height: 1.2;
    
    @media screen and (max-width:770px) {
        font-size: 0.8rem;
        margin-bottom: 0.4rem;
    }
`;

const ServiceText = styled.p`
    margin-bottom: 1.2rem;
    padding: 0;
    font-size: 0.9rem;
    min-height: 3.4rem;
    text-align: center;
    color: ${colors.darkColor};
    overflow: hidden;
    
    @media screen and (max-width:770px) {
        margin-bottom: 0.8rem;
        padding: 0.2rem;
        font-size: 0.7rem;
        height: 3rem;
    }
`;

const ServiceLink = styled(Link)`
    display: inline-block;
    background-color: ${colors.background};
    color: ${colors.textColor};
    padding: 0.55rem 1.15rem;
    border-radius: 2rem;
    text-decoration: none;
    font-size: 0.95rem;
    box-shadow: 0 0.6rem 1.1rem rgba(26, 35, 126, 0.18);
    transition: background-color 0.25s ease, transform 0.25s ease;

    &:hover {
        background-color: ${colors.secondColor};
        transform: translateY(-0.1rem);
    }
    
    @media screen and (max-width:770px) {
        margin: 0;
    }
`;


function Service() {
    return (
        <>
             <Title>
                    Nos <span>Services</span>
            </Title>
            <ServicesContainer>
            {servicesData.map((service) => (
                    <Services key={service.id} >
                        <ServiceImg>
                            <img src={service.image} alt="" />
                        </ServiceImg>
                        <ServiceContent>
                            <ServiceTitle>{service.title}</ServiceTitle>
                            <ServiceText>{service.description}</ServiceText>
                            <ServiceLink 
                                to={`/Services/${encodeURIComponent(service.title)}`}
                            >
                                Plus
                            </ServiceLink>
                        </ServiceContent>
                    </Services>
                ))}
            </ServicesContainer>
        </>
    );
}

export default Service;
